import React, { useEffect } from "react"
import ReactDOM from "react-dom"
const GeoModalPortal = (props) => {

  const modalRoot = document.createElement("div")
  modalRoot.setAttribute("uk-modal", "bg-close: false")
  modalRoot.id = "modal-center"

  useEffect(() => {
    document.body.appendChild(modalRoot)

    const UIkit = require("../../../uikit/dist/js/uikit.min.js")

    if (typeof window !== "undefined") {
      UIkit.modal("#modal-center", {
        escClose: false,
        bgClose: false,
      })
      // .show()
    }

    return () => {
      document.body.removeChild(modalRoot)
    }
  })

  return ReactDOM.createPortal(props.children, modalRoot)
}

export default GeoModalPortal